var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FINALS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.64767295,4.26133682 C1.72446387,3.78260616 2.07618658,3.52442699 2.70284109,3.48679933 C3.3294956,3.44917166 4.76188206,3.44917166 7.00000046,3.48679933 L12.6748449,12.3040082 L1.64767295,7.32055233 L1.64767295,4.26133682 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.18816105,2.54337803 C5.43606614,1.61800273 5.87334595,1.13650125 6.50000046,1.09887359 C7.12665497,1.06124593 8.34707445,1.06124593 10.1612589,1.09887359 C12.5630066,2.69541944 14.0931554,4.04342896 14.7517052,5.14290215 C14.9617084,5.49351022 15.6109811,5.71045183 15.7496318,6.18733655 C15.9470615,6.8663898 16.0103498,8.27025244 15.9394967,10.3989245 C15.9587817,11.8935454 15.8705644,12.7019493 15.6748449,12.8241362 C14.6844557,13.442432 12.7419546,11.6657336 11.5577168,11.1305468 C10.0224376,10.4367156 7.71908965,8.50005075 4.64767295,5.32055233 L5.18816105,2.54337803 Z",
    id: "Rectangle-Copy-9",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 12,
    y: 11,
    width: 4,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    fill: "#FFFFFF",
    x: 7,
    y: 12,
    width: 5.25,
    height: 4.24,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "copy_icon",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.501201,1.406272 L15.7496318,6.10651863 C14.1207123,6.21427585 13.0256516,6.21427585 12.4644498,6.10651863 C11.903248,5.99876142 11.3957337,5.66776142 10.941907,5.11351865 L10.501201,1.406272 Z",
    id: "Path-7-Copy",
    fill: "#D4D8DD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "tooltip",
    transform: "translate(0.941907, 0.700000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(0.000000, 2.300000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.19414702,0.929825552 L10.8077248,5.10651908 C9.17880525,5.2142763 8.08374456,5.2142763 7.52254275,5.10651908 C6.96134095,4.99876186 6.4538267,4.66776187 6,4.1135191 L6.19414702,0.929825552 Z",
    id: "Path-7",
    fill: "#D4D8DD"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0.0580934565,
    y: 5.7,
    width: 11,
    height: 8,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    fill: "#FFFFFF",
    x: 0.0580934565,
    y: 2.7,
    width: 6,
    height: 5,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.058093, 0.000000)",
    fill: "#000A29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3287996,5.17093664 C15.3268566,5.14651969 15.3216752,5.12296451 15.3126078,5.09969658 C15.3087218,5.0899298 15.3061311,5.08045028 15.3012735,5.07097075 C15.2854055,5.04052137 15.2659753,5.01179554 15.2384492,4.98737859 L15.2384492,4.98709133 L15.2384492,4.98709133 C15.2384492,4.98709133 15.2381254,4.98680407 15.2381254,4.98651681 L9.71056059,0.0841666816 C9.68271065,0.0591752096 9.64967933,0.0416524534 9.61502883,0.0275767967 C9.60628524,0.0238424388 9.59657015,0.0218316307 9.58717889,0.0189590477 C9.55932895,0.0106285571 9.53083134,0.00517064938 9.50136223,0.00373435789 C9.49456166,0.00315984129 9.48840877,0 9.48128436,0 L5.82970425,0 C4.63863369,0 3.67003879,0.859476831 3.67003879,1.91601285 L3.67003879,2.39688325 L2.1599893,2.39688325 C0.968918738,2.39688325 2.91038305e-11,3.25636008 2.91038305e-11,4.3128961 L2.91038305e-11,14.0842744 C2.91038305e-11,15.1408104 0.968918738,16 2.1599893,16 L9.50362908,16 C10.6943758,16 11.6632945,15.1408104 11.6632945,14.0842744 L11.6632945,13.6031168 L13.1736679,13.6031168 C14.3647384,13.6031168 15.3333333,12.7439272 15.3333333,11.6873912 L15.3333333,5.19047021 C15.3333333,5.18357601 15.3294473,5.17783084 15.3287996,5.17093664 Z M9.80544468,0.980699833 L14.2274318,4.90321191 L11.317761,4.90321191 C10.4838821,4.90321191 9.80544468,4.30140577 9.80544468,3.56171565 L9.80544468,0.980699833 Z M11.0156216,14.0839871 C11.0156216,14.82339 10.3371842,15.4251961 9.50362908,15.4251961 L2.1599893,15.4251961 C1.32611037,15.4251961 0.647672953,14.82339 0.647672953,14.0839871 L0.647672953,4.3128961 C0.647672953,3.57320598 1.32611037,2.97139985 2.1599893,2.97139985 L3.99387527,2.97139985 L5.48805677,2.97139985 L5.48805677,5.9585989 C5.48805677,7.01513492 6.45665167,7.87432449 7.6473984,7.87432449 L11.0152978,7.87432449 L11.0152978,13.3155712 L11.0156216,14.0839871 L11.0156216,14.0839871 Z M10.5577168,7.2998079 L7.64772223,7.2998079 C6.81416714,7.2998079 6.13605356,6.69828902 6.13605356,5.9585989 L6.13605356,3.37758308 L10.5577168,7.2998079 Z M13.1736679,13.0286002 L11.6632945,13.0286002 L11.6632945,7.5870662 C11.6632945,7.58045925 11.6594085,7.57442683 11.6587608,7.56781989 C11.6568178,7.54340293 11.6519603,7.51984775 11.6428928,7.49629257 C11.6390068,7.48681305 11.6360923,7.47733352 11.6312347,7.46756674 C11.6156906,7.43740462 11.5959366,7.40867879 11.5684105,7.38426184 L11.5684105,7.38426184 L11.5684105,7.38426184 C11.5684105,7.38397458 11.5680866,7.38368732 11.5680866,7.38368732 L6.04084564,2.48104993 C6.01267186,2.45634572 5.97996438,2.43882296 5.94531388,2.4247473 C5.93592262,2.42101294 5.92653136,2.41871488 5.91681627,2.4158423 C5.88896633,2.40722455 5.86111639,2.4020539 5.83164727,2.40061761 C5.82484671,2.40004309 5.81869381,2.39688325 5.81156941,2.39688325 L4.31738791,2.39688325 L4.31738791,1.91601285 C4.31738791,1.17632273 4.99582533,0.574516598 5.82938042,0.574516598 L9.15744789,0.574516598 L9.15744789,3.56200291 C9.15744789,4.61853893 10.1263666,5.47801576 11.3174372,5.47801576 L14.6850137,5.47801576 L14.6850137,11.6873912 C14.6856604,12.426794 14.007223,13.0286002 13.1736679,13.0286002 Z",
    id: "Shape"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.adfb0497.svg";
export { ForwardRef as ReactComponent };